// FETCH ALL PROPERTIES FROM TEAM MASTER
export const FETCH_SALES_ORDER_DEMAND_REQUEST = 'FETCH_SALES_ORDER_DEMAND_REQUEST';
export const FETCH_SALES_ORDER_DEMAND_SUCCESS = 'FETCH_SALES_ORDER_DEMAND_SUCCESS';
export const FETCH_SALES_ORDER_DEMAND_FAILURE = 'FETCH_SALES_ORDER_DEMAND_FAILURE';

export const FETCH_SALES_ORDER_DEMAND_FABRIC_REQUEST = 'FETCH_SALES_ORDER_DEMAND_FABRIC_REQUEST';
export const FETCH_SALES_ORDER_DEMAND_FABRIC_SUCCESS = 'FETCH_SALES_ORDER_DEMAND_FABRIC_SUCCESS';
export const FETCH_SALES_ORDER_DEMAND_FABRIC_FAILURE = 'FETCH_SALES_ORDER_DEMAND_FABRIC_FAILURE';

export const FETCH_SALES_ORDER_DEMAND_FABRIC_COLOR_REQUEST = 'FETCH_SALES_ORDER_DEMAND_FABRIC_COLOR_REQUEST';
export const FETCH_SALES_ORDER_DEMAND_FABRIC_COLOR_SUCCESS = 'FETCH_SALES_ORDER_DEMAND_FABRIC_COLOR_SUCCESS';
export const FETCH_SALES_ORDER_DEMAND_FABRIC_COLOR_FAILURE = 'FETCH_SALES_ORDER_DEMAND_FABRIC_COLOR_FAILURE';

//FETCH DEMAND INVOICE DATA
export const FETCH_DEMAND_INVOICE_REQUEST = 'FETCH_DEMAND_INVOICE_REQUEST';
export const FETCH_DEMAND_INVOICE_SUCCESS = 'FETCH_DEMAND_INVOICE_SUCCESS';
export const FETCH_DEMAND_INVOICE_FAILURE = 'FETCH_DEMAND_INVOICE_FAILURE';

export const FETCH_ACCESSORIES_DEMAND_REQUEST = 'FETCH_ACCESSORIES_DEMAND_REQUEST';
export const FETCH_ACCESSORIES_DEMAND_SUCCESS = 'FETCH_ACCESSORIES_DEMAND_SUCCESS';
export const FETCH_ACCESSORIES_DEMAND_FAILURE = 'FETCH_ACCESSORIES_DEMAND_FAILURE';

export const FETCH_ACCESSORIES_DEMAND_SUMMARY_REQUEST = 'FETCH_ACCESSORIES_DEMAND_SUMMARY_REQUEST';
export const FETCH_ACCESSORIES_DEMAND_SUMMARY_SUCCESS = 'FETCH_ACCESSORIES_DEMAND_SUMMARY_SUCCESS';
export const FETCH_ACCESSORIES_DEMAND_SUMMARY_FAILURE = 'FETCH_ACCESSORIES_DEMAND_SUMMARY_FAILURE';

export const RESET_DEMAND_INVOICE = 'RESET_DEMAND_INVOICE';

//FETCH DEMAND YARN REQ INVOICE DATA
export const FETCH_DEMAND_YARN_REQUIREMENT_INVOICE_REQUEST = 'FETCH_DEMAND_YARN_REQUIREMENT_INVOICE_REQUEST';
export const FETCH_DEMAND_YARN_REQUIREMENT_INVOICE_SUCCESS = 'FETCH_DEMAND_YARN_REQUIREMENT_INVOICE_SUCCESS';
export const FETCH_DEMAND_YARN_REQUIREMENT_INVOICE_FAILURE = 'FETCH_DEMAND_YARN_REQUIREMENT_INVOICE_FAILURE';

export const RESET_DEMAND_YARN_REQUIREMENT_INVOICE = 'RESET_DEMAND_YARN_REQUIREMENT_INVOICE';

//FETCH DEMAND FAB REQ INVOICE DATA
export const FETCH_DEMAND_FABRIC_REQUIREMENT_INVOICE_REQUEST = 'FETCH_DEMAND_FABRIC_REQUIREMENT_INVOICE_REQUEST';
export const FETCH_DEMAND_FABRIC_REQUIREMENT_INVOICE_SUCCESS = 'FETCH_DEMAND_FABRIC_REQUIREMENT_INVOICE_SUCCESS';
export const FETCH_DEMAND_FABRIC_REQUIREMENT_INVOICE_FAILURE = 'FETCH_DEMAND_FABRIC_REQUIREMENT_INVOICE_FAILURE';

export const RESET_DEMAND_FABRIC_REQUIREMENT_INVOICE = 'RESET_DEMAND_FABRIC_REQUIREMENT_INVOICE';

//FETCH DEMAND FAB COLOR INVOICE DATA
export const FETCH_DEMAND_FABRIC_COLOR_INVOICE_REQUEST = 'FETCH_DEMAND_FABRIC_COLOR_INVOICE_REQUEST';
export const FETCH_DEMAND_FABRIC_COLOR_INVOICE_SUCCESS = 'FETCH_DEMAND_FABRIC_COLOR_INVOICE_SUCCESS';
export const FETCH_DEMAND_FABRIC_COLOR_INVOICE_FAILURE = 'FETCH_DEMAND_FABRIC_COLOR_INVOICE_FAILURE';

export const RESET_DEMAND_FABRIC_COLOR_INVOICE = 'RESET_DEMAND_FABRIC_COLOR_INVOICE';

export const FETCH_DEMAND_ACCESSORIES_REQUIREMENT_INVOICE_REQUEST = 'FETCH_DEMAND_ACCESSORIES_REQUIREMENT_INVOICE_REQUEST';
export const FETCH_DEMAND_ACCESSORIES_REQUIREMENT_INVOICE_SUCCESS = 'FETCH_DEMAND_ACCESSORIES_REQUIREMENT_INVOICE_SUCCESS';
export const FETCH_DEMAND_ACCESSORIES_REQUIREMENT_INVOICE_FAILURE = 'FETCH_DEMAND_ACCESSORIES_REQUIREMENT_INVOICE_FAILURE';

export const RESET_DEMAND_ACCESSORIES_REQUIREMENT_INVOICE = 'RESET_DEMAND_ACCESSORIES_REQUIREMENT_INVOICE';

export const FETCH_DEMAND_PROGRAM_WISE_COST_INVOICE_REQUEST = 'FETCH_DEMAND_PROGRAM_WISE_COST_INVOICE_REQUEST';
export const FETCH_DEMAND_PROGRAM_WISE_COST_INVOICE_SUCCESS = 'FETCH_DEMAND_PROGRAM_WISE_COST_INVOICE_SUCCESS';
export const FETCH_DEMAND_PROGRAM_WISE_COST_INVOICE_FAILURE = 'FETCH_DEMAND_PROGRAM_WISE_COST_INVOICE_FAILURE';

export const RESET_DEMAND_PROGRAM_WISE_COST_INVOICE = 'RESET_DEMAND_PROGRAM_WISE_COST_INVOICE';

export const FETCH_DEMAND_COLOUR_WISE_SIZE_INVOICE_REQUEST = 'FETCH_DEMAND_COLOUR_WISE_SIZE_INVOICE_REQUEST';
export const FETCH_DEMAND_COLOUR_WISE_SIZE_INVOICE_SUCCESS = 'FETCH_DEMAND_COLOUR_WISE_SIZE_INVOICE_SUCCESS';
export const FETCH_DEMAND_COLOUR_WISE_SIZE_INVOICE_FAILURE = 'FETCH_DEMAND_COLOUR_WISE_SIZE_INVOICE_FAILURE';

export const RESET_DEMAND_COLOUR_WISE_SIZE_INVOICE = 'RESET_DEMAND_COLOUR_WISE_SIZE_INVOICE';

//FETCH PROCESS COST PER PCS INVOICE DATA
export const FETCH_DEMAND_PROCESS_COST_PER_PCS_INVOICE_REQUEST = 'FETCH_DEMAND_PROCESS_COST_PER_PCS_INVOICE_REQUEST';
export const FETCH_DEMAND_PROCESS_COST_PER_PCS_INVOICE_SUCCESS = 'FETCH_DEMAND_PROCESS_COST_PER_PCS_INVOICE_SUCCESS';
export const FETCH_DEMAND_PROCESS_COST_PER_PCS_INVOICE_FAILURE = 'FETCH_DEMAND_PROCESS_COST_PER_PCS_INVOICE_FAILURE';

export const RESET_DEMAND_PROCESS_COST_PER_PCS_INVOICE = 'RESET_DEMAND_PROCESS_COST_PER_PCS_INVOICE';

export const SET_DEMAND_PASSWORD_FOR_REPLACE = 'SET_DEMAND_PASSWORD_FOR_REPLACE';

export const GET_FABRIC_REPLACE_TRIGGER_REQUEST = 'GET_FABRIC_REPLACE_TRIGGER_REQUEST';
export const GET_FABRIC_REPLACE_TRIGGER_SUCCESS = 'GET_FABRIC_REPLACE_TRIGGER_SUCCESS';
export const GET_FABRIC_REPLACE_TRIGGER_FAILURE = 'GET_FABRIC_REPLACE_TRIGGER_FAILURE';

export const CREATE_POST_DATA_GET = 'CREATE_POST_DATA_GET';

export const POST_FARBRIC_DEMAND_DATA_REQUEST = 'POST_FARBRIC_DEMAND_DATA_REQUEST';
export const POST_FARBRIC_DEMAND_DATA_FAILURE = 'POST_FARBRIC_DEMAND_DATA_FAILURE';
export const POST_FARBRIC_DEMAND_DATA_SUCCESS = 'POST_FARBRIC_DEMAND_DATA_SUCCESS';

export const GET_LOADED_DIA_REQUEST = 'GET_LOADED_DIA_REQUEST';
export const GET_LOADED_DIA_SUCCESS = 'GET_LOADED_DIA_SUCCESS';
export const GET_LOADED_DIA_FAILURE = 'GET_LOADED_DIA_FAILURE';

export const POST_FABRIC_COMMON_REQUEST = 'POST_FABRIC_COMMON_REQUEST';
export const POST_FABRIC_COMMON_SUCCESS = 'POST_FABRIC_COMMON_SUCCESS';
export const POST_FABRIC_COMMON_FAILURE = 'POST_FABRIC_COMMON_FAILURE';


export const GET_LOADING_SALES_ORDER_REQUEST = 'GET_LOADING_SALES_ORDER_REQUEST';
export const GET_LOADING_SALES_ORDER_SUCCESS = 'GET_LOADING_SALES_ORDER_SUCCESS';
export const GET_LOADING_SALES_ORDER_FAILURE = 'GET_LOADING_SALES_ORDER_FAILURE';


export const GET_DEMAND_CONTENT_SALES_ORDER_REQUEST = 'GET_DEMAND_CONTENT_SALES_ORDER_REQUEST';
export const GET_DEMAND_CONTENT_SALES_ORDER_SUCCESS = 'GET_DEMAND_CONTENT_SALES_ORDER_SUCCESS';
export const GET_DEMAND_CONTENT_SALES_ORDER_FAILURE = 'GET_DEMAND_CONTENT_SALES_ORDER_FAILURE';

export const CREATE_FABRIC_COLOR_DEMAND_ADDITIONAL_REQUIREMENT_REQUEST = 'CREATE_FABRIC_COLOR_DEMAND_ADDITIONAL_REQUIREMENT_REQUEST';
export const CREATE_FABRIC_COLOR_DEMAND_ADDITIONAL_REQUIREMENT_SUCCESS = 'CREATE_FABRIC_COLOR_DEMAND_ADDITIONAL_REQUIREMENT_SUCCESS';
export const CREATE_FABRIC_COLOR_DEMAND_ADDITIONAL_REQUIREMENT_FAILURE = 'CREATE_FABRIC_COLOR_DEMAND_ADDITIONAL_REQUIREMENT_FAILURE';

export const CREATE_FABRIC_COLOR_DEMAND_REPLACE_REQUEST = 'CREATE_FABRIC_COLOR_DEMAND_REPLACE_REQUEST';
export const CREATE_FABRIC_COLOR_DEMAND_REPLACE_SUCCESS = 'CREATE_FABRIC_COLOR_DEMAND_REPLACE_SUCCESS';
export const CREATE_FABRIC_COLOR_DEMAND_REPLACE_FAILURE = 'CREATE_FABRIC_COLOR_DEMAND_REPLACE_FAILURE';

export const CREATE_NEW_FABRIC_COLOR_DEMAND_REQUEST = 'CREATE_NEW_FABRIC_COLOR_DEMAND_REQUEST';
export const CREATE_NEW_FABRIC_COLOR_DEMAND_SUCCESS = 'CREATE_NEW_FABRIC_COLOR_DEMAND_SUCCESS';
export const CREATE_NEW_FABRIC_COLOR_DEMAND_FAILURE = 'CREATE_NEW_FABRIC_COLOR_DEMAND_FAILURE';

export const CREATE_NEW_FABRIC_CHECK_REQUEST = 'CREATE_NEW_FABRIC_CHECK_REQUEST';
export const CREATE_NEW_FABRIC_CHECK_SUCCESS = 'CREATE_NEW_FABRIC_CHECK_SUCCESS';
export const CREATE_NEW_FABRIC_CHECK_FAILURE = 'CREATE_NEW_FABRIC_CHECK_FAILURE';

export const CREATE_FABRIC_COLOR_DEMAND_ADDITIONAL_REQUIREMENT_USERFORM_RESET = 'CREATE_FABRIC_COLOR_DEMAND_ADDITIONAL_REQUIREMENT_USERFORM_RESET';

export const FAILURE_DEMAND_CHECKER = 'FAILURE_DEMAND_CHECKER';

export const CREATE_ACCESSORIES_DEMAND_ADDITIONAL_REQUIREMENT_REQUEST = 'CREATE_ACCESSORIES_DEMAND_ADDITIONAL_REQUIREMENT_REQUEST';
export const CREATE_ACCESSORIES_DEMAND_ADDITIONAL_REQUIREMENT_SUCCESS = 'CREATE_ACCESSORIES_DEMAND_ADDITIONAL_REQUIREMENT_SUCCESS';
export const CREATE_ACCESSORIES_DEMAND_ADDITIONAL_REQUIREMENT_FAILURE = 'CREATE_ACCESSORIES_DEMAND_ADDITIONAL_REQUIREMENT_FAILURE';

export const CREATE_ACCESSORIES_DEMAND_REPLACE_REQUEST = 'CREATE_ACCESSORIES_DEMAND_REPLACE_REQUEST';
export const CREATE_ACCESSORIES_DEMAND_REPLACE_SUCCESS = 'CREATE_ACCESSORIES_DEMAND_REPLACE_SUCCESS';
export const CREATE_ACCESSORIES_DEMAND_REPLACE_FAILURE = 'CREATE_ACCESSORIES_DEMAND_REPLACE_FAILURE';

export const CREATE_NEW_ACCESSORIES_DEMAND_REQUEST = 'CREATE_NEW_ACCESSORIES_DEMAND_REQUEST';
export const CREATE_NEW_ACCESSORIES_DEMAND_SUCCESS = 'CREATE_NEW_ACCESSORIES_DEMAND_SUCCESS';
export const CREATE_NEW_ACCESSORIES_DEMAND_FAILURE = 'CREATE_NEW_ACCESSORIES_DEMAND_FAILURE';

export const UPDATE_DEMAND_REVERT_STATUS_REQUEST = 'UPDATE_DEMAND_REVERT_STATUS_REQUEST';
export const UPDATE_DEMAND_REVERT_STATUS_SUCCESS = 'UPDATE_DEMAND_REVERT_STATUS_SUCCESS';
export const UPDATE_DEMAND_REVERT_STATUS_FAILURE = 'UPDATE_DEMAND_REVERT_STATUS_FAILURE';

export const UPDATE_PATTERN__REQUEST = 'UPDATE_PATTERN__REQUEST';
export const UPDATE_PATTERN__SUCCESS = 'UPDATE_PATTERN__SUCCESS';
export const UPDATE_PATTERN__FAILURE = 'UPDATE_PATTERN__FAILURE';

export const UPDATE_REMARKS_REQUEST = 'UPDATE_REMARKS_REQUEST';
export const UPDATE_REMARKS_SUCCESS = 'UPDATE_REMARKS_SUCCESS';
export const UPDATE_REMARKS_FAILURE = 'UPDATE_REMARKS_FAILURE';

export const RESET_ALL_INVOICE = 'RESET_ALL_INVOICE';

export const FETCH_SALES_ORDER_REQ_REPORT_BY_STYLE_REQUEST = 'FETCH_SALES_ORDER_REQ_REPORT_BY_STYLE_REQUEST';
export const FETCH_SALES_ORDER_REQ_REPORT_BY_STYLE_SUCCESS = 'FETCH_SALES_ORDER_REQ_REPORT_BY_STYLE_SUCCESS';
export const FETCH_SALES_ORDER_REQ_REPORT_BY_STYLE_FAILURE = 'FETCH_SALES_ORDER_REQ_REPORT_BY_STYLE_FAILURE';
